console.log("[CustomFeaturedProducts] Script loaded!");

(function () {
	function getAddToCartFlyout() {
		return window.AddToCartFlyout || window.theme?.AddToCartFlyout;
	}

	function getProductGridItem() {
		return window.theme?.ProductGridItem;
	}

	function waitForDependencies(callback) {
		// Wait for AddToCartFlyout (Empire), Splide (Vite), and ProductGridItem
		const hasAddToCart = !!getAddToCartFlyout();
		const hasSplide = !!window.Splide;
		const hasProductGridItem = !!getProductGridItem();

		console.log("[CustomFeaturedProducts] Checking dependencies:", {
			hasAddToCart,
			hasSplide,
			hasProductGridItem,
			theme: window.theme,
		});

		if (hasAddToCart && hasSplide && hasProductGridItem) {
			console.log("[CustomFeaturedProducts] All dependencies ready!");
			callback();
		} else {
			setTimeout(function () {
				waitForDependencies(callback);
			}, 50);
		}
	}

	class CustomFeaturedProducts {
		constructor(section) {
			if (!window.Splide) {
				console.warn(
					"[CustomFeaturedProducts] Splide not found, skipping initialization"
				);
				return;
			}

			if (document.readyState === "loading") {
				document.addEventListener("DOMContentLoaded", () =>
					this.initializeSection(section)
				);
			} else {
				this.initializeSection(section);
			}
		}

		initializeSection(section) {
			// Handle different input types: raw DOM element, jQuery object, or section object with .el
			if (section instanceof HTMLElement) {
				this.container = section;
			} else if (section.el && section.el.jquery) {
				this.container = section.el.get(0);
			} else if (section.el) {
				this.container = section.el;
			} else {
				this.container = null;
			}

			if (!this.container) {
				return;
			}

			this.Splide = window.Splide;
			this.tabsSlider = this.container.querySelector("[data-tabs-slider]");
			this.productSliders = this.container.querySelectorAll(
				"[data-products-slider]"
			);
			this.tabs = this.container.querySelectorAll("[data-tab]");
			this.addToCartButtons =
				this.container.querySelectorAll("[data-quick-buy]");

			this.init();
		}
		init() {
			this.initTabsSlider();
			this.initProductSliders();
			this.setupTabsAccessibility();
			this.initProductItems();
			this.initAddToCart();
		}

		initProductItems() {
			// Initialize ProductGridItem for each product to enable quickshop modal
			const ProductGridItem = getProductGridItem();
			if (!ProductGridItem) {
				console.warn("[CustomFeaturedProducts] ProductGridItem not found");
				return;
			}

			this.productItems = [];
			const productItemEls = this.container.querySelectorAll(
				"[data-product-item]"
			);
			// Get the section ID from the Shopify section wrapper
			const sectionWrapper = this.container.closest(
				'[id^="shopify-section-"]'
			);
			const sectionId = sectionWrapper
				? sectionWrapper.id.replace("shopify-section-", "")
				: this.container.dataset.sectionId;

			console.log("[CustomFeaturedProducts] Initializing product items:", {
				productItemCount: productItemEls.length,
				sectionId: sectionId,
				sectionWrapper: sectionWrapper,
			});

			productItemEls.forEach((productItem, index) => {
				this.productItems.push(
					new ProductGridItem({
						el: productItem,
						id: sectionId,
						lazy: false,
					})
				);
			});

			// Debug: Add manual click listener to quickshop-slim buttons
			const quickshopButtons = this.container.querySelectorAll(
				"[data-quickshop-slim]"
			);
			console.log(
				"[CustomFeaturedProducts] Found quickshop-slim buttons:",
				quickshopButtons.length
			);
			quickshopButtons.forEach((btn, i) => {
				btn.addEventListener("click", e => {
					console.log(
						`[CustomFeaturedProducts] Quickshop button ${i} clicked!`,
						{
							button: btn,
							productItem: btn.closest("[data-product-item]"),
							event: e,
						}
					);
				});
			});
		}

		initAddToCart() {
			if (!this.addToCartButtons.length) return;

			this.addToCartButtons.forEach(button => {
				button.addEventListener("click", this._handleAddToCart.bind(this));
			});
		}
		_handleAddToCart(event) {
			event.preventDefault();

			if (this.addToCartFlyout) {
				this.addToCartFlyout.unload();
			}

			const atcButton = event.currentTarget;
			const variantID = atcButton.getAttribute("data-variant-id");
			const packQuantity =
				parseInt(atcButton.getAttribute("data-pack-quantity")) || 1;
			const formData = [
				{ name: "id", value: variantID },
				{ name: "quantity", value: packQuantity },
			];

			const options = {
				atcButton,
			};

			const AddToCartFlyout = getAddToCartFlyout();
			if (!AddToCartFlyout) {
				console.warn("[CustomFeaturedProducts] AddToCartFlyout not found");
				return;
			}
			this.addToCartFlyout = new AddToCartFlyout(formData, options);
		}

		initTabsSlider() {
			if (!this.tabsSlider) return;

			new this.Splide(this.tabsSlider, {
				gap: "1.38rem",
				pagination: false,
				arrows: false,
				pagination: false,
				autoWidth: true,
				focus: 0,
				omitEnd: true,
				perPage: 2,
				padding: { right: "2.6rem" },
				mediaQuery: "min",
				breakpoints: {
					767: {
						perPage: 3,
					},
					1283: {
						perPage: 5,
						gap: "3.94rem",
						padding: { right: "0" },
					},
				},
			}).mount();
		}

		initProductSliders() {
			if (!this.productSliders.length) return;

			this.sliderInstances = Array.from(this.productSliders).map(slider => {
				return new this.Splide(slider, {
					perPage: 2,
					gap: ".94rem",
					pagination: false,
					arrows: false,
					pagination: false,
					mediaQuery: "min",
					breakpoints: {
						767: {
							perPage: 3,
						},
						1238: {
							perPage: 5,
							gap: "1.25rem",
						},
					},
				}).mount();
			});
		}

		setupTabsAccessibility() {
			if (!this.tabs.length) return;

			// Set initial states for tabs and panels
			this.tabs.forEach((tab, index) => {
				// Set ARIA attributes
				tab.setAttribute("role", "tab");
				tab.setAttribute("aria-selected", index === 0 ? "true" : "false");
				tab.setAttribute("tabindex", index === 0 ? "0" : "-1");

				// Ensure each tab has an aria-controls attribute matching its panel
				const panelId = tab.getAttribute("aria-controls");
				if (!panelId) {
					console.warn("Tab is missing aria-controls attribute");
					return;
				}
			});

			// Set initial panel visibility
			this.productSliders.forEach((panel, index) => {
				panel.setAttribute("role", "tabpanel");
				panel.hidden = index !== 0;
			});

			// Add click handlers to tabs
			this.tabs.forEach(tab => {
				tab.addEventListener("click", e => {
					e.preventDefault();
					this.switchTab(tab);
				});
			});

			// Add keyboard navigation
			this.container.addEventListener("keydown", e => {
				const targetTab = e.target.closest("[data-tab]");
				if (!targetTab) return;

				const currentIndex = Array.from(this.tabs).indexOf(targetTab);

				switch (e.key) {
					case "ArrowLeft":
						e.preventDefault();
						this.focusTab(currentIndex - 1);
						break;
					case "ArrowRight":
						e.preventDefault();
						this.focusTab(currentIndex + 1);
						break;
					case "Home":
						e.preventDefault();
						this.focusTab(0);
						break;
					case "End":
						e.preventDefault();
						this.focusTab(this.tabs.length - 1);
						break;
				}
			});
		}

		switchTab(selectedTab) {
			if (!selectedTab) return;

			// Update tab states
			this.tabs.forEach(tab => {
				const isSelected = tab === selectedTab;
				tab.setAttribute("aria-selected", isSelected);
				tab.setAttribute("tabindex", isSelected ? "0" : "-1");

				// Add/remove selected class for styling
				if (isSelected) {
					tab.classList.add("selected");
				} else {
					tab.classList.remove("selected");
				}
			});

			// Show selected panel, hide others
			const selectedPanelId = selectedTab.getAttribute("aria-controls");
			if (!selectedPanelId) return;

			this.productSliders.forEach(panel => {
				const shouldShow = panel.id === selectedPanelId;
				panel.hidden = !shouldShow;

				// If showing panel, refresh the Splide slider to ensure proper rendering
				if (shouldShow) {
					const sliderInstance = this.sliderInstances.find(
						instance => instance.root === panel
					);
					if (sliderInstance) {
						sliderInstance.refresh();
					}
				}
			});
		}

		focusTab(index) {
			if (index < 0) index = this.tabs.length - 1;
			if (index >= this.tabs.length) index = 0;

			const tab = this.tabs[index];
			tab.focus();
			this.switchTab(tab);
		}
	}
	function initSections() {
		const sections = document.querySelectorAll(".custom-featured-products");
		sections.forEach(section => {
			new CustomFeaturedProducts(section);
		});
	}
	waitForDependencies(function () {
		// Initial page load
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", initSections);
		} else {
			initSections();
		}

		// Handle Shopify page transitions - CRUCIAL PART FOR NAVIGATION
		document.addEventListener("page:load", initSections);
		document.addEventListener("shopify:section:load", function (event) {
			const section = event.target;
			if (section.classList.contains("custom-featured-products")) {
				new CustomFeaturedProducts(section);
			}
		});
	});
})();
